<script>
  import { leaderboardActivityOptions } from "./utils/leaderboard";
  import { leaderboardData } from "./utils/stores";
  import Table from "./Table.svelte";
  import LeaderboardRanking from "./LeaderboardRanking/LeaderboardRanking.svelte";

  export let filteredLeaderboardStats;
  export let leaderboardSortBy;
</script>

<LeaderboardRanking
  data={filteredLeaderboardStats}
  selectedLeaderboardOption={leaderboardSortBy}
  dataType={leaderboardActivityOptions.find(
    (opt) => opt.value === leaderboardSortBy,
  ).type}
/>
<Table
  data={filteredLeaderboardStats}
  columns={$leaderboardData.columns}
  component="leaderboard"
  bind:sortBy={leaderboardSortBy}
/>
